/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Switch = /** @class */ (function () {
    function Switch() {
        this.VERSION = '1.0';
        this.COMPONENTS = $el('r-switch', { all: true });
        this._create(this.COMPONENTS);
    }
    Switch.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'switch');
        var Input = target.querySelector('input[type="hidden"]');
        var isChecked = Input.value === 'true';
        var isDisabled = target.classList.contains(PREFIX.switch + "-disabled");
        var isLoading = target.classList.contains(PREFIX.switch + "-loading");
        var changeState = function (flag, state, cls) {
            if (flag && !type.isBol(flag))
                return;
            if (flag && state)
                return;
            else
                target.classList.add(PREFIX.switch + "-" + cls);
            if (flag == false)
                target.classList.remove(PREFIX.switch + "-" + cls);
        };
        return {
            get checked() {
                return isChecked;
            },
            set checked(newVal) {
                changeState(newVal, isChecked, 'checked');
            },
            get disabled() {
                return isDisabled;
            },
            set disabled(newVal) {
                changeState(newVal, isDisabled, 'disabled');
            },
            get loading() {
                return isLoading;
            },
            set loading(newVal) {
                changeState(newVal, isLoading, 'loading');
            },
            events: function (_a) {
                var onChange = _a.onChange;
                var checked;
                var handler = function () {
                    checked = JSON.parse(Input.value);
                    onChange && type.isFn(onChange, checked);
                };
                bind(target, 'click', handler);
            }
        };
    };
    Switch.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            node.setAttribute('tabindex', '0');
            var _a = _this._attrs(node), checked = _a.checked, loading = _a.loading, disabled = _a.disabled, size = _a.size, open = _a.open, close = _a.close, trueColor = _a.trueColor, falseColor = _a.falseColor;
            _this._setSize(node, size);
            _this._setMainTemplate(node);
            _this._setDisabled(node, disabled);
            _this._setLoading(node, loading);
            _this._setStatusBgc(node, checked, trueColor, falseColor);
            var SwitchInner = node.querySelector("." + PREFIX.switch + "-inner");
            var HiddenInput = node.querySelector('input[type="hidden"]');
            _this._setChecked(node, HiddenInput, checked);
            _this._setStatusText(SwitchInner, checked, open, close);
            _this._handleChange(node, HiddenInput, SwitchInner, {
                open: open,
                close: close,
                trueColor: trueColor,
                falseColor: falseColor
            });
            removeAttrs(node, [
                'checked',
                'loading',
                'disabled',
                'size',
                'open',
                'close',
                'true-color',
                'false-color'
            ]);
        });
    };
    Switch.prototype._setDisabled = function (node, disabled) {
        if (!disabled)
            return;
        node.classList.add(PREFIX.switch + "-disabled");
    };
    Switch.prototype._setLoading = function (node, loading) {
        if (!loading)
            return;
        node.classList.add(PREFIX.switch + "-loading");
    };
    Switch.prototype._setSize = function (node, size) {
        if (!size || size === 'default')
            return;
        node.classList.add(PREFIX.switch + "-" + size);
    };
    Switch.prototype._setMainTemplate = function (node) {
        var template = "\n        <input type=\"hidden\" /> \n        <span class=\"" + PREFIX.switch + "-inner\"></span>\n        ";
        setHtml(node, template);
    };
    Switch.prototype._handleChange = function (node, input, textContainer, options) {
        var _this = this;
        var handler = function () {
            var isLoading = node.classList.contains(PREFIX.switch + "-loading");
            var isDisabled = node.classList.contains(PREFIX.switch + "-disabled");
            if (isDisabled || isLoading)
                return false;
            var isChecked = node.classList.contains(PREFIX.switch + "-checked");
            var flag = false;
            if (isChecked) {
                node.classList.remove(PREFIX.switch + "-checked");
            }
            else {
                flag = !flag;
                node.classList.add(PREFIX.switch + "-checked");
            }
            _this._setChecked(node, input, flag);
            _this._setStatusBgc(node, flag, options.trueColor, options.falseColor);
            _this._setStatusText(textContainer, flag, options.open, options.close);
        };
        bind(node, 'click', handler);
    };
    Switch.prototype._setChecked = function (node, input, checked) {
        if (checked) {
            node.classList.add(PREFIX.switch + "-checked");
        }
        input.value = "" + checked;
    };
    Switch.prototype._setStatusText = function (elem, checked, open, close) {
        var changeText = function (text, flag) {
            if (text) {
                if (flag) {
                    setHtml(elem, text);
                }
                else {
                    setHtml(elem, text);
                }
            }
        };
        changeText(open, checked);
        changeText(close, !checked);
        checked ? setHtml(elem, open) : setHtml(elem, close);
    };
    Switch.prototype._setStatusBgc = function (node, checked, trueColor, falseColor) {
        if (trueColor) {
            if (checked) {
                setCss(node, 'backgroundColor', trueColor);
                setCss(node, 'borderColor', trueColor);
            }
        }
        if (falseColor) {
            if (!checked) {
                setCss(node, 'backgroundColor', falseColor);
                setCss(node, 'borderColor', falseColor);
            }
        }
    };
    Switch.prototype._attrs = function (node) {
        return {
            checked: getBooleanTypeAttr(node, 'checked'),
            loading: getBooleanTypeAttr(node, 'loading'),
            disabled: getBooleanTypeAttr(node, 'disabled'),
            size: getStrTypeAttr(node, 'size', 'default'),
            open: getStrTypeAttr(node, 'open', ''),
            close: getStrTypeAttr(node, 'close', ''),
            trueColor: getStrTypeAttr(node, 'true-color', ''),
            falseColor: getStrTypeAttr(node, 'false-color', '')
        };
    };
    return Switch;
}());
export default Switch;
